<template>
<v-flex align-self-start>
    <v-layout my-5>
        <v-flex xs12 xl8 offset-xl2>
            <v-layout align-center>
                <h1 class="text-xs-left display-2 my-2">Create Semester</h1>
                <v-spacer></v-spacer>
            </v-layout>
        </v-flex>
    </v-layout>

    <v-layout row wrap>
        <v-flex xs12 xl8 offset-xl2 mb-5>
            <v-card>
                <div v-if="laravelErrors.active" class="text-xs-center pa-3">
                    <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">{{ msg }}
                    </v-chip>
                </div>
                <v-card-text>
                    <v-form @submit.prevent="createSemester" class="pa-3">
                        <v-text-field name="name" label="Name" v-model="name"></v-text-field>
                        <v-layout>
                            <v-spacer></v-spacer>
                            <v-btn color="blue" class="white--text" @click="createSemester">Create</v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>

    <v-dialog persistent v-model="addedAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" type="success">Semester successfully created!</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.stop="redirect">ok!</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</v-flex>
</template>

<script>
export default {
    data() {
        return {
            name: '',
            addedAlert: false,
            laravelErrors: {
                active: false,
                messages: []
            }
        }
    },
    methods: {
        createSemester() {
            this.$store.dispatch('addSemester', {
                    'name': this.name
                }).then(() => {
                    this.clearErrors()
                    this.addedAlert = true
                })
                .catch((e) => {
                    this.laravelErrors.active = true
                    if (e.response.data.errors) {
                        this.laravelErrors.messages = e.response.data.errors.name
                    } else {
                        this.laravelErrors.messages = [e.response.data.msg]
                    }
                })
        },
        clearErrors() {
            this.laravelErrors.active = false
            this.laravelErrors.messages = []
        },
        redirect() {
            let newSemester = this.$store.getters.semestersRouterFormat.find(s => s.name === this.name)
            this.$router.push({
                name: 'AdminEditSemester',
                params: {
                    'semester_slug': newSemester.slug
                }
            })
        }
    }
}
</script>
